export const SORT_ORDER = Object.freeze({
  ASC: 'asc',
  ASCEND: 'ascend',
  DESC: 'desc',
  DESCEND: 'descend',
})
